import React, { useState } from 'react';

interface SummaryProps {
  content: string;
  maxLength?: number;
}

const Summary: React.FC<SummaryProps> = ({ content, maxLength = 300 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!content) {
    return null;
  }

  const textContent = content.replace(/<[^>]*>/g, '');
  const shouldShowViewMore = textContent.length > maxLength;

  const displayContent = shouldShowViewMore && !isExpanded ? content.substring(0, maxLength) + '...' : content;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className="summary-section"
      style={{
        margin: '20px 16px',
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        fontSize: '14px',
        lineHeight: '1.4',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0'
      }}
    >
      <div
        className="summary-content"
        dangerouslySetInnerHTML={{ __html: displayContent }}
        style={{
          color: '#333333',
          marginBottom: shouldShowViewMore ? '8px' : '0'
        }}
      />
      {shouldShowViewMore && (
        <button
          className="view-more-btn"
          onClick={toggleExpanded}
          style={{
            background: 'none',
            border: 'none',
            color: '#008cff',
            cursor: 'pointer',
            fontSize: '14px',
            padding: '0',
            fontWeight: '500',
            textDecoration: 'none'
          }}
        >
          {isExpanded ? 'View Less' : 'View More'}
        </button>
      )}
    </div>
  );
};

export default Summary;
